<template>
    <div class="form">
        <div class="form-item">
            <div class="label">
                <div>手机号码</div>
                <div class="error">{{ errMsg.userName }}</div>
            </div>
            <div class="input">
                <el-input
                    size="large"
                    :class="{ error: errMsg.userName }"
                    @focus="onClearErr('userName')"
                    v-model="form.userName"
                    placeholder="请输入您的手机号"
                    :maxLength="11"
                ></el-input>
            </div>
        </div>
        <div class="form-item">
            <div class="label">
                <div>密码</div>
                <div class="error">{{ errMsg.password }}</div>
            </div>
            <div class="input">
                <el-input
                    size="large"
                    :class="{ error: errMsg.password }"
                    @focus="onClearErr('password')"
                    v-model="form.password"
                    type="password"
                    placeholder="请输入您的密码"
                ></el-input>
            </div>
        </div>
        <div class="form-item">
            <div class="label">
                <div>验证码</div>
                <div class="error">{{ errMsg.code }}</div>
            </div>
            <div class="input graph-code">
                <el-input
                    size="large"
                    :class="{ error: errMsg.code }"
                    @focus="onClearErr('code')"
                    v-model="form.code"
                    placeholder="请输入验证码"
                ></el-input>
                <img
                    v-if="validateCodeSrc"
                    :src="validateCodeSrc"
                    @click="getValidateCode"
                    class="code"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { validatePhone } from '@/utils/validate';
import { v4 as uuidv4 } from 'uuid';
import { ApiGetGraphCode } from '@/common/api';
export default {
    name: 'Account',
    data() {
        return {
            validateCodeSrc: '',
            graphicCodeLoading: false, // 请求图形验证码的loading
            form: {
                userName: '',
                password: '',
                code: '',
                uuid: ''
            },
            errMsg: {
                userName: '',
                password: '',
                code: ''
            }
        };
    },
    created() {
        let accountCache =
            window.localStorage.getItem('accountInfo') || undefined;
        accountCache = accountCache && JSON.parse(accountCache);
        if (accountCache && accountCache.userName && accountCache.password) {
            this.form = {
                ...this.form,
                userName: accountCache.userName,
                password: accountCache.password
            };
        }
        this.getValidateCode();
    },
    methods: {
        // 图形验证码
        getValidateCode() {
            if (this.graphicCodeLoading) return;
            this.graphicCodeLoading = true;
            const uuid = uuidv4();
            this.form.code = '';
            ApiGetGraphCode(uuid, 'login')
                .then(res => {
                    this.graphicCodeLoading = false;
                    return (
                        'data:image/png;base64,' +
                        btoa(
                            new Uint8Array(res.data).reduce(
                                (data, byte) =>
                                    data + String.fromCharCode(byte),
                                ''
                            )
                        )
                    );
                })
                .then(data => {
                    this.graphicCodeLoading = false;
                    this.validateCodeSrc = data;
                    this.form.uuid = uuid;
                })
                .catch(err => {
                    this.graphicCodeLoading = false;
                    this.$message.error(err.message || '获取图片验证码失败');
                });
        },
        // 提交
        submit() {
            this.errMsg = {
                ...this.errMsg,
                userName: validatePhone(this.form.userName),
                password: this.form.password ? '' : '请输入您的密码',
                code: this.form.code ? '' : '请输入验证码'
            };
            const { userName, password, code } = this.errMsg;
            if (userName || password || code) return false;
            return this.form;
        },
        // 清除错误信息
        onClearErr(type) {
            this.errMsg = {
                ...this.errMsg,
                [type]: ''
            };
        }
    }
};
</script>
<style lang="scss" scoped>
$baseColor: #f56c6c;
.form {
    .form-item {
        margin-bottom: 18px;
        text-align: left;
    }
    .graph-code {
        display: flex;
        .code {
            margin-left: 20px;
            width: 100px;
            height: 40px;
            background: #000;
        }
    }
    .error {
        border-color: $baseColor;
    }
    .label {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #2d2e33;
        line-height: 14px;
        position: relative;
        .error {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: $baseColor;
            line-height: 12px;
        }
        .tips {
            position: absolute;
        }
    }
}
</style>
